import { Data } from '@types'

import data from '../data.json'

// @ts-expect-error - wp global variable
export const quiz = (import.meta.env.MODE === 'development' ? data : quiz_data) as Data
